import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChart from './../../component/chart'
import Service from './service';
import AreaSplineChartWithHeader from './../../component/areaSplineChartWithHeader'
import Utils from './../../component/utils/utils';

class PackageTotalNewRepatSeriesView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false,
        selectedInterval: 60,

    }

    componentDidMount () {
        Service.event.onFetchSeriesPackagesByDay.add((data) => {
            console.log("*** On fetch chart data");
            console.log(data);

            this.setState({
                renderChart : true,
                responseTableData: data,
                histogramChartCategoriesList: data.chartData.categoryList,
                histogramChartSeriesDataList1: data.chartData.seriesDataList1,
                histogramChartSeriesDataList2: data.chartData.seriesDataList2,
                histogramChartSeriesDataList3: data.chartData.seriesDataList3,
            });
        });

        Service.fetchPackageSeriesByDay(this.state.selectedInterval);
    }

    componentWillUnmount() {

    }

    constructor() {
        super();
        // setting default attribute values
        this.intervalOptions = Utils.intervalOptions;
    }

    selectElementChange = (event) => {
        this.setState({ selectedInterval: event.target.value});
        Service.fetchPackageSeriesByDay(event.target.value);
    };

    // refresh button actions
    searchButtonAction = () => {
        Service.fetchPackageSeriesByDay(this.state.selectedInterval);
    };

    render() {
        return (
            <div>
                { this.state.renderChart ? <AreaSplineChartWithHeader
                    chartTitle = {"Total, New, Repeat Packages by Day For The Last " + this.state.selectedInterval + " days"}
                    histogramChartCategoriesList = {this.state.histogramChartCategoriesList}
                    histogramChartSeriesDataList = {
                        [{
                            name: 'Total Packages',
                            data: this.state.histogramChartSeriesDataList1
                        },{
                            name: 'New Packages',
                            data: this.state.histogramChartSeriesDataList2
                        },{
                            name: 'Repeat Packages',
                            data: this.state.histogramChartSeriesDataList3
                        }]
                    }
                    selectElementChange = {this.selectElementChange}
                    searchButtonAction = {this.searchButtonAction}
                    selectDropdownValues = {this.intervalOptions}
                    yAxisTitle = "Total/New/Repeat Packages"
                    headerIconClass = "fa fa-credit-card"
                /> : '' }
            </div>
        );
    }
}

export default PackageTotalNewRepatSeriesView;